<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="selectedUrl ? `transaction/placement/sendRecommendClass/${inputs.id}` : `transaction/placement/sendRecommendClass`"
			>
			
				<div class="form-group row align-items-center">
				<label for="inputs_academic_calendar_id" class="col-sm-3 mb-0">
					Semester
				</label>
				<app-input
					id="inputs_academic_calendar_id"
					class="col-sm-9"
					type="advance-search-select"
					v-model="input_academic_calendar_id"
					:fetch-url="`master/academic-calendar`"
					@input="setAcademicCalendarId"
					placeholder="Semester"
					list-value-field="academic_calendar_name"
					required
				/>
				</div>
				<div class="form-group row align-items-center" >
					<label for="input_teaching_type" class="col-sm-3 mb-0">
						Teaching Type
					</label>
					<app-input
						id="input_teaching_type"
						class="col-sm-9"
						type="advance-search-select"
						v-model="input_teaching_type"
						:loaded-per-time="10"
						@input="setTeachingType"
						fetch-url="master/teaching-type"
						placeholder="Teaching Type"
						list-value-field="teaching_type_label"
						required
					/>
				</div>
				<div class="form-group row align-items-center" >
					<label for="input_category_product" class="col-sm-3 mb-0">
						Product Category
					</label>
					<app-input
						id="input_category_product"
						v-model="input_product_category"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						@input="setCategoryProduct"
						fetch-url="master/product-category"
						placeholder="Category Product"
						list-value-field="label"
						required
					/>
				</div>
				<div class="form-group row align-items-center" >
					<label for="input_type_class" class="col-sm-3 mb-0">
						Class Type
					</label>
					<app-input
						id="input_type_class"
						class="col-sm-9"
						type="advance-search-select"
						v-model="input_class_type"
						:loaded-per-time="10"
						@input="setClassType"
						fetch-url="master/course-type"
						placeholder="Class Type"
						list-value-field="course_type_label"
						required
					/>
				</div>
				<div class="form-group row align-items-center" >
					<label for="input_product_level" class="col-sm-3 mb-0">
						Product Level
					</label>
					<app-input
						id="input_product_level"
						class="col-sm-9"
						type="advance-search-select"
						v-model="input_product_level"
						:loaded-per-time="10"
						@input="setProductLevel"
						fetch-url="master/product-level"
						placeholder="Product Level"
						list-value-field="product_level_label"
						required
					/>
				</div>
				<div class="form-group row align-items-center" >
					<label for="input_product_status" class="col-sm-3 mb-0">
						Product Status
					</label>
					<app-input
						id="input_product_status"
						class="col-sm-9"
						type="advance-search-select"
						v-model="input_product_status"
						:loaded-per-time="10"
						@input="setProductStatus"
						fetch-url="master/product-status"
						placeholder="Product Status"
						list-value-field="product_status_label"
						required
					/>
				</div>
				<div class="form-group row align-items-center" >
					<label for="input_payment_status" class="col-sm-3 mb-0">
						Payment Status
					</label>
					<app-input
						id="input_payment_status"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_payment_status"
						@input="setPaymentStatus"
						fetch-url="master/payment-status"
						placeholder="Payment Status"
						list-value-field="payment_status_label"
						required
					/>
				</div>
				<div class="form-group row align-items-center" >
					<label for="inputs_product_id" class="col-sm-3 mb-0">
						Product Name
					</label>
					<app-input
						id="inputs_product_id"
						class="col-sm-9"
						type="text"
						v-model="input_product_name"
						placeholder="Product Name"
						disabled
					/>
				</div>
				<div class="form-group row align-items-center" >
					<label for="inputs_packages_name" class="col-sm-3 mb-0">
						Package Name
					</label>
					<app-input
						id="inputs_packages_name"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_packages_name"
						@input="setPackagesNameValue"
						:fetch-url="inputs.product_id && inputs.academic_calendar_id
							? `master/list-packages?product_id=${inputs.product_id}&semester=${inputs.academic_calendar_id}`
							: ''"
						placeholder="Packages Name"
						list-value-field="package_name"
						required
					/>
				</div>
				<div class="form-group row align-items-center" >
					<label for="inputs_invoice_type" class="col-sm-3 mb-0">
						Invoice Type
					</label>
					<app-input
						id="inputs_invoice_type"
						class="col-sm-9"
						type="text"
						v-model="input_invoice_type"
						placeholder="Invoice Type"
						disabled
					/>
				</div>
                
				<div class="form-group row align-items-center" >
					<label for="inputs_due_date" class="col-sm-3 mb-0">
						Due Date
					</label>
					<app-input
						id="inputs_due_date"
						class="col-sm-9"
						type="date"
						v-model="inputs.due_date"
						placeholder="Due Date"
						required
					/>
				</div>
                
				<div class="form-group row align-items-center" >
					<label for="inputs_clc_start_date" class="col-sm-3 mb-0">
						Start Date
					</label>
					<app-input
						id="inputs_clc_start_date"
						class="col-sm-9"
						type="text"
						v-model="inputs.clc_start_date"
						placeholder="CLC Start Date"
						disabled
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_mon" class="col-sm-3 mb-0"> Mon </label>
					<app-input
						id="inputs_mon"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_start_1"
						placeholder="Start Time"
						:disabled="true"
					/>
					<app-input
						id="inputs_mon"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_end_1"
						placeholder="End Time"
						:disabled="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_tue" class="col-sm-3 mb-0"> Tue </label>
					<app-input
						id="inputs_tue"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_start_2"
						placeholder="Start Time"
						:disabled="true"
					/>
					<app-input
						id="inputs_tue"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_end_2"
						placeholder="End Time"
						:disabled="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_wed" class="col-sm-3 mb-0"> Wed </label>
					<app-input
						id="inputs_wed"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_start_3"
						placeholder="Start Time"
						:disabled="true"
					/>
					<app-input
						id="inputs_wed"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_end_3"
						placeholder="End Time"
						:disabled="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_thu" class="col-sm-3 mb-0"> Thu </label>
					<app-input
						id="inputs_thu"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_start_4"
						placeholder="Start Time"
						:disabled="true"
					/>
					<app-input
						id="inputs_thu"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_end_4"
						placeholder="End Time"
						:disabled="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_fri" class="col-sm-3 mb-0"> Fri </label>
					<app-input
						id="inputs_fri"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_start_5"
						placeholder="Start Time"
						:disabled="true"
					/>
					<app-input
						id="inputs_fri"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_end_5"
						placeholder="End Time"
						:disabled="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_sat" class="col-sm-3 mb-0"> Sat </label>
					<app-input
						id="inputs_sat"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_start_6"
						placeholder="Start Time"
						:disabled="true"
					/>
					<app-input
						id="inputs_sat"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_end_6"
						placeholder="End Time"
						:disabled="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_sun" class="col-sm-3 mb-0"> Sun </label>
					<app-input
						id="inputs_sun"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_start_7"
						placeholder="Start Time"
						:disabled="true"
					/>
					<app-input
						id="inputs_sun"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_end_7"
						placeholder="End Time"
						:disabled="true"
					/>
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../../../Mixins/ModalMixin";

export default {
	name: "PlacementRecommendTableForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		placementId: {
			type: Number,
			required: true,
		},
	},
	data() {
		return {
      		input_academic_calendar_id: {},
			preloader: false,
			input_invoice_type:'',
			input_product_name:'',
			input_teaching_type:'',
			input_product_category:'',
			input_class_type:'',
			input_product_level:'',
			input_product_status:'',
			input_payment_status:'',
			dummy:{
				'teaching_type_id' : null,
				'product_category_id' : null,
				'class_type_id' : null,
				'product_level_id' : null,
				'product_status_id' : null,
				'payment_status_id' : null,
			},
			inputs: {
				product_id : null,
				placement_id: this.placementId,
				invoice_type:'',
				start_date: null,
				clc_start_date:'',
				time_start_1: "",
				time_start_2: "",
				time_start_3: "",
				time_start_4: "",
				time_start_5: "",
				time_start_6: "",
				time_start_7: "",
				time_end_1: "",
				time_end_2: "",
				time_end_3: "",
				time_end_4: "",
				time_end_5: "",
				time_end_6: "",
				time_end_7: "",
			},
    		input_packages_name: {},  
      		input_product: {},
            input_course_schedule_id: this.value
                ? {
                    id: this.value.id || 0,
                    course_schedule_name: this.value.course_schedule_name || "",
                    day_id: this.value.day_id?.id || "",
                    course_group_id: this.value.course_group_id?.id || "",
                    }
                : {
                    id: 0,
                    course_schedule_name: "",
                    day_id: "",
                    course_group_id: "",
                    },
			modalId: this.formId,
			modalTitle: this.$t("add"),
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}
	},
	methods: {
        async fetchCourseSchedule() {
			try {
				let time_start = this.input_course_schedule_id.time_start.slice(
					0,
					-3
				);
				let time_end = this.input_course_schedule_id.time_end.slice(
					0,
					-3
				);

				if (
					this.input_course_schedule_id?.day_id?.day_name === "Monday"
				) {
					this.inputs.time_start_1 = time_start;
					this.inputs.time_end_1 = time_end;
				} else if (
					this.input_course_schedule_id?.day_id?.day_name ===
					"Tuesday"
				) {
					this.inputs.time_start_2 = time_start;
					this.inputs.time_end_2 = time_end;
				} else if (
					this.input_course_schedule_id?.day_id?.day_name ===
					"Wednesday"
				) {
					this.inputs.time_start_3 = time_start;
					this.inputs.time_end_3 = time_end;
				} else if (
					this.input_course_schedule_id?.day_id?.day_name ===
					"Thursday"
				) {
					this.inputs.time_start_4 = time_start;
					this.inputs.time_end_4 = time_end;
				} else if (
					this.input_course_schedule_id?.day_id?.day_name === "Friday"
				) {
					this.inputs.time_start_5 = time_start;
					this.inputs.time_end_5 = time_end;
				} else if (
					this.input_course_schedule_id?.day_id?.day_name ===
					"Saturday"
				) {
					this.inputs.time_start_6 = time_start;
					this.inputs.time_end_6 = time_end;
				} else if (
					this.input_course_schedule_id?.day_id?.day_name === "Sunday"
				) {
					this.inputs.time_start_7 = time_start;
					this.inputs.time_end_7 = time_end;
				}
			} catch (error) {
			}
		},
		async setPackagesNameValue(selectedPackage) {
			this.inputs.package_id = selectedPackage.id;
			
			if (selectedPackage?.id) {
				try {
					const res = await axios.get(`/master/packages/get-by-id/${selectedPackage.id}`);
			
					const data = res.data;
				   	for (let i = 1; i <= 7; i++) {
						this.inputs[`time_start_${i}`] = "";
						this.inputs[`time_end_${i}`] = "";
					}
					if (!data.course_list_packages || data.course_list_packages.length === 0) {
						this.inputs.start_date = '';
						this.inputs.clc_start_date = '';
						for (let i = 1; i <= 7; i++) {
							this.inputs[`time_start_${i}`] = "";
							this.inputs[`time_end_${i}`] = "";
						}
						this.input_packages_name = {};
						this.inputs.package_id = null;
						
						Swal.fire({
							icon: 'warning',
							title: '',
							text: 'Invalid package, please check again.',
						});
						return false;
					}
					if (Array.isArray(data.course_list_packages)) {
						data.course_list_packages.forEach(item => {
							const day = item.course?.day;
							const timeStart = item.course?.time_start;
							const timeEnd = item.course?.time_end;

							if (item.course?.course_date_start) {
								this.inputs.start_date = item.course.course_date_start;
							}

							if (item.course?.course_date_clc_start) {
								this.inputs.clc_start_date = item.course.course_date_clc_start;
							}

							// kalau day valid (1–7)
							if (day >= 1 && day <= 7) {
								this.inputs[`time_start_${day}`] = timeStart ? timeStart.slice(0, 5) : "";
								this.inputs[`time_end_${day}`] = timeEnd ? timeEnd.slice(0, 5) : "";
							}
						});
					}
					
  					this.$forceUpdate();
				} catch (err) {
				}
			}
		},
		setProductValueEditData(data,packageId){

			if (data && data.hasOwnProperty("id")) {
				this.$set(this.inputs, "product_id", data.id);
			}
						
			this.inputs.product_id = data?.id || null;
			this.input_product_name = data?.name || null;
			
			this.$set(this, "input_product", data);

			this.fetchPackagesByProduct(this.inputs.product_id,this.inputs.academic_calendar_id,packageId);

		},
        setProductValue(data) {

			if (data?.payment_status?.payment_status_code) {
				this.inputs.invoice_type = data.payment_status.payment_status_code;
				this.input_invoice_type = data.payment_status.payment_status_code;
			}

			if (data && data.hasOwnProperty("id")) {
				this.$set(this.inputs, "product_id", data.id);
			}
						
			this.inputs.product_id = data?.id || null;

			// reset package kalau product tidak ada
			if (!this.inputs.product_id) {
				this.input_packages_name = {};
				this.inputs.package_id = null;
				return;
			}

			this.$set(this, "input_product", data);
			// fetch package list berdasarkan product id
			this.fetchPackagesByProduct(this.inputs.product_id,this.inputs.academic_calendar_id);
			// this.resetCourseId();
			// this.resetCourseSchedule();
		},
		
		setAcademicCalendarId(data) {
			this.inputs.academic_calendar_id = data.id;
			this.input_academic_calendar_id = data;
		},
		async fetchPackagesByProduct(productId,academic_calendar_id,packageId='') {
			try {
				const res = await axios.get("/master/list-packages", {
					params: { product_id: productId,semester : academic_calendar_id }
				});

				// assign data ke dropdown packages
				const packages = res.data.data || [];

				// kalau cuma ada 1 package, langsung pilih otomatis
				// if (packages.length === 1) {
					
				// 	this.input_packages_name = packages[0];
				// 	this.inputs.package_name = packages[0].package_name;
					
				// 	try {
				// 		const res = await axios.get(`/master/packages/name/${packages[0].package_name}/${productId}`);
				// 		const data = res.data;
						
				// 		for (let i = 1; i <= 7; i++) {
				// 			this.inputs[`time_start_${i}`] = "";
				// 			this.inputs[`time_end_${i}`] = "";
				// 		}

				// 		if (Array.isArray(data.course_list_packages)) {
				// 			data.course_list_packages.forEach(item => {
				// 				const day = item.course?.day;
				// 				const timeStart = item.course?.time_start;
				// 				const timeEnd = item.course?.time_end;

				// 				if (item.course?.start_date) {
				// 					this.inputs.start_date = item.course.start_date;
				// 				}

				// 				if (item.course?.clc_start_date) {
				// 					this.inputs.clc_start_date = item.course.clc_start_date;
				// 				}

				// 				// kalau day valid (1–7)
				// 				if (day >= 1 && day <= 7) {
				// 					this.inputs[`time_start_${day}`] = timeStart ? timeStart.slice(0, 5) : "";
				// 					this.inputs[`time_end_${day}`] = timeEnd ? timeEnd.slice(0, 5) : "";
				// 				}
				// 			});
				// 		}
						
				// 		this.$forceUpdate();
				// 	} catch (err) {
				// 		console.error("Gagal mengambil data package:", err);
				// 	}
				// } else {
					
					if(packageId !=''){
						const selectedPackage = packages.find(p => p.id === packageId);
  						this.input_packages_name = selectedPackage;
						this.inputs.package_id = packageId;
						
						try {
							const res = await axios.get(`/master/packages/get-by-id/${packageId}`);
							const data = res.data;
							
							for (let i = 1; i <= 7; i++) {
								this.inputs[`time_start_${i}`] = "";
								this.inputs[`time_end_${i}`] = "";
							}

							if (!data.course_list_packages || data.course_list_packages.length === 0) {
								
								this.inputs.start_date = '';
								this.inputs.clc_start_date = '';
								for (let i = 1; i <= 7; i++) {
									this.inputs[`time_start_${i}`] = "";
									this.inputs[`time_end_${i}`] = "";
								}
								this.input_packages_name = {};
								this.inputs.package_id = null;
								
								Swal.fire({
									icon: 'warning',
									title: '',
									text: 'invalid package, please check again.',
								});
								return false;
							}

							if (Array.isArray(data.course_list_packages)) {
								data.course_list_packages.forEach(item => {
									const day = item.course?.day;
									const timeStart = item.course?.time_start;
									const timeEnd = item.course?.time_end;

									if (item.course?.start_date) {
										this.inputs.start_date = item.course.start_date;
									}

									if (item.course?.clc_start_date) {
										this.inputs.clc_start_date = item.course.clc_start_date;
									}
									
									// kalau day valid (1–7)
									if (day >= 1 && day <= 7) {
										this.inputs[`time_start_${day}`] = timeStart ? timeStart.slice(0, 5) : "";
										this.inputs[`time_end_${day}`] = timeEnd ? timeEnd.slice(0, 5) : "";
									}
								});
							}
							
							this.$forceUpdate();
						} catch (err) {
						}
					}else{
						this.input_packages_name = {};
						this.inputs.package_id = null;
					}
				// }
			} catch (err) {
				this.input_packages_name = {};
				this.inputs.package_id = null;
			}
		},
		submit() {
			if(this.inputs.product_id == null){
				
				Swal.fire({
					icon: 'warning',
					title: '',
					text: 'Product not found, please check again.',
				});
				return false;

			}
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			this.inputs = response.data;
            
			this.inputs.invoice_type = response.data.invoice_type;
			this.input_invoice_type = response.data.invoice_type;
			this.input_academic_calendar_id = response.data.academic_calendar;

			if (
				response.data.package.course &&
				response.data.package.course.length > 0
			) {
				this.inputs.time_start_1 = response.data.package.course[0].time_start_1;
				this.inputs.time_end_1 = response.data.package.course[0].time_end_1;
				this.inputs.time_start_2 = response.data.package.course[0].time_start_2;
				this.inputs.time_end_2 = response.data.package.course[0].time_end_2;
				this.inputs.time_start_3 = response.data.package.course[0].time_start_3;
				this.inputs.time_end_3 = response.data.package.course[0].time_end_3;
				this.inputs.time_start_4 = response.data.package.course[0].time_start_4;
				this.inputs.time_end_4 = response.data.package.course[0].time_end_4;
				this.inputs.time_start_5 = response.data.package.course[0].time_start_5;
				this.inputs.time_end_5 = response.data.package.course[0].time_end_5;
				this.inputs.time_start_6 = response.data.package.course[0].time_start_6;
				this.inputs.time_end_6 = response.data.package.course[0].time_end_6;
				this.inputs.time_start_7 = response.data.package.course[0].time_start_7;
				this.inputs.time_end_7 = response.data.package.course[0].time_end_7;
			}

			this.dummy.teaching_type_id = response.data.product.teaching_type.teaching_type_id;
			this.input_teaching_type = response.data.product.teaching_type;
			this.dummy.product_category_id = response.data.product.product_category.id;
			this.input_product_category = response.data.product.product_category;
			this.dummy.class_type_id = response.data.product.course_type.id;
			this.input_class_type = {
				id: response.data.product.course_type?.id,
				course_type_desc: response.data.product.course_type?.course_type_desc,
				course_type_label: response.data.product.course_type?.course_type_label,
				};
			this.dummy.product_level_id = response.data.product.product_level.product_level_id;
			this.input_product_level = response.data.product.product_level;
			this.dummy.product_status_id = response.data.product.product_status.product_status_id;
			this.input_product_status = response.data.product.product_status;
			this.dummy.payment_status_id = response.data.product.payment_status.payment_status_id;
			this.input_payment_status = response.data.product.payment_status;

			let product = {
				id: null,
				name: null,
				code: null,
				is_active: null
			}
			
			if (response.data.product?.id) {
			
				this.setProductValueEditData(response.data.product,response.data.package_id);
			}
			
			this.preloader = false;
		},
		setTeachingType(data){
			this.dummy.teaching_type_id = data.teaching_type_id;
			this.input_teaching_type = data;
			this.getProduct();
		},
		setCategoryProduct(data){
			this.dummy.product_category_id = data.id;
			this.input_product_category = data;
			this.getProduct();
		},
		setClassType(data){
			this.dummy.class_type_id = data.id;
			this.input_class_type = {
				id: data?.id,
				course_type_desc: data?.course_type_desc,
				course_type_label: data?.course_type_label,
			};
			this.getProduct();
		},
		setProductLevel(data){
			this.dummy.product_level_id = data.product_level_id;
			this.input_product_level = data;
			this.getProduct();
		},
		setProductStatus(data){
			this.dummy.product_status_id = data.product_status_id;
			this.input_product_status = data;
			this.getProduct();
		}, 
		setPaymentStatus(data){
			this.dummy.payment_status_id = data.id;
			this.input_payment_status = data;
			this.getProduct();
		},    
		async getProduct(){
			try {
				if(this.dummy.teaching_type_id != null && this.dummy.product_category_id != null && this.dummy.class_type_id != null
					&& this.dummy.product_level_id != null && this.dummy.product_status_id != null && this.dummy.payment_status_id != null
				){
					const getProduct = await axios.get("/master/product/by-criteria", {
						params: { 	teaching_type_id: this.dummy.teaching_type_id,
									product_category_id : this.dummy.product_category_id,
									class_type_id : this.dummy.class_type_id,
									product_level_id : this.dummy.product_level_id,
									product_status_id : this.dummy.product_status_id,
									payment_status_id : this.dummy.payment_status_id
								}
					});
					const products = getProduct.data || [];
					if(products){

						if (products?.payment_status?.payment_status_code) {
							this.inputs.invoice_type = products.payment_status.payment_status_code;
							this.input_invoice_type = products.payment_status.payment_status_code;
						}
						this.inputs.product_id = products.id;
						this.input_product_name = products.name;
						this.fetchPackagesByProduct(this.inputs.product_id,this.inputs.academic_calendar_id);
					}else{
						this.inputs.product_id = null;
						this.input_product_name = null;
						this.inputs.invoice_type = null;
						this.input_invoice_type = null;
						this.input_packages_name = {};
						this.inputs.package_id = null;

					}

				}


			} catch (err) {
			}
		}
	},
};
</script>
<style scoped>
	.input-span{
		background: #eee;height: 46px;border: 1px solid #4b6c9d; border-radius: 6px !important;padding: 12px;
	}
</style>
